import http from '../clients/Axios'

export default class SettingService {
  async get(param) {
    param = param ? param : ''
    return await http.get(`/app/setting${param}`)
  }

  async update(id, form) {
    return await http.post(`/app/setting/${id}`, form)
  }
}
